import { Button, Icon, UI, HStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

export namespace FilterButtonTypes {
  export type Props = {
    onPress?: () => void;
    appliedFilterCount?: number;
  };
}

export const FilterButton: React.FC<FilterButtonTypes.Props> = ({
  onPress,
  appliedFilterCount,
}) => {
  return (
    <Button
      variant="secondary"
      rightIcon={!appliedFilterCount ? <Icon name="Funnel" size="xxxs" /> : undefined}
      onPress={onPress}
      fontSize={Typography['fontsize.md']}
      fontWeight={Typography['fontweight.semibold']}>
      <HStack space={Spacing['stack.nano']} alignItems="center">
        Filtrar
        {appliedFilterCount !== undefined && appliedFilterCount > 0 && (
          <Box
            rounded="full"
            w="20px"
            h="20px"
            alignItems="center"
            justifyContent="center"
            bg="brand.tertiary.light">
            <UI.Text variant="regular" fontSize={Typography['fontsize.xs']} color="neutral.white">
              {appliedFilterCount}
            </UI.Text>
          </Box>
        )}
      </HStack>
    </Button>
  );
};
